import React from "react";
import Parse from "parse";

import {
  AdminLayout,
  usePermission,
  usePromise,
  useTranslation,
} from "@opendash/core";

import { TenantConfig } from "../types";

import { message } from "antd";
import { ParseObject } from "@opendash/plugin-parse";

interface Props {
  type: "appearance" | "navigation" | "contact";
}

export const fields = {
  appearance: [
    "title",
    "logo",
    "logoUrl",
    "primaryColor",
    "secondaryColor",
    "primaryTextColor",
    "secondaryTextColor",
    "frontpageBackgroundImage",
    "frontpageContactIcon",
    "frontpageGlossarIcon",
    "frontpageVideoIcon",
    // "pageTitleInvoice",
    // "pageTitleVideo",
    // "pageTitleGlossary",
    // "pageTitleContact",
  ],
  navigation: [
    "menuItemLabel",
    "menuItemUrl",
    "menuItemIcon",
    "menuItem2Label",
    "menuItem2Url",
    "menuItem2Icon",
    "menuItem3Label",
    "menuItem3Url",
    "menuItem3Icon",
    "imprintUrl",
    "tosUrl",
    "privacyUrl",
    "imprintText",
    "tosText",
    "privacyText",
  ],
  contact: [
    "addressText",
    "contactText",
    "contactPhone",
    "contactWhatsappLabel",
    "contactWhatsappLink",
    "contactFax",
    "contactWeb",
    "contactEmail",
    "contactImage",
    "contactImageAlt",
    "openingHoursText",
    "routeDescriptionText",
    "googleMaps",
  ],
};

export const TenantConfigRoute = React.memo<Props>(function TenantConfigRoute({
  type,
}) {
  const t = useTranslation();

  const isTenantAdmin = usePermission("od-tenant-admin");

  const [config, error, loading] = usePromise(async () => {
    if (!isTenantAdmin) {
      message.error(t("app:config.missing_permission_message"));
      return undefined;
    }

    const currentUserTenant: Parse.Object | undefined =
      Parse.User.current()?.get("tenant");

    if (!currentUserTenant) {
      message.error(t("app:config.missing_permission_message"));
      return undefined;
    }

    const config = await new Parse.Query(TenantConfig)
      .equalTo("tenant", currentUserTenant)
      .first();

    if (!config) {
      message.error(t("app:config.missing_permission_message"));
      return undefined;
    }

    return config;
  }, [isTenantAdmin]);

  return (
    <AdminLayout contentPadding>
      <ParseObject
        object={config}
        fields={fields[type]}
        editFields={fields[type]}
        disableDelete
      />
    </AdminLayout>
  );
});
